import { JobDetailsPage } from "Components/CareerPages/JobDetailsPage";
import { EmployerSubDomainWrapper } from "layouts/EmployerSubDomainLayout/EmployerSubDomainWrapper";
import { Navigate, Route, Routes } from "react-router-dom";
import { CareerPagesHome } from "../Components/CareerPages/CareerPagesHome";

export const EmployerSubDomainRouter = () => {
    return (<>
        <Routes>
            <Route path="/" element={<EmployerSubDomainWrapper />} >
                <Route path="/" element={<Navigate replace to="/careers/posted-jobs" />} />
                <Route path="/posted-jobs" element={<CareerPagesHome />} />
                <Route path="/posted-jobs/:jobId" element={<JobDetailsPage />} />
            </Route>
        </Routes>
    </>)
}
